// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","351":"commons","691":"component---src-pages-index-tsx","810":"728c80d1"}[chunkId] + "-" + {"218":"7fef78ff4403eacce01d","351":"19d88613ac2b2047905c","691":"d9d10a9f6961d54327d3","810":"c7b7cbaa54ac3e356a4c"}[chunkId] + ".js";
};